<div class="container mx-auto max-w-[1240px] px-4 md:px-8 my-8">
  <div class="border-b border-gray-200 pb-4 mb-4">
    <h2 class="text-xl font-bold text-gray-800">Extras</h2>
    <p class="text-gray-500 mt-2">Noticias, recursos, eventos y más...</p>
  </div>

  <div class="flex flex-col md:flex-row gap-6">
    <!-- Recursos -->
    <button (click)="openModal('Recursos')"
      class="w-full md:w-1/3 rounded-lg overflow-hidden shadow-md cursor-pointer"
      [style.background]="
        'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/assets/recursos-bg.jpg)'
      "
      [style.background-position]="'center'"
      [style.background-size]="'cover'">
      <div class="relative h-48 flex items-center justify-center">
        <div class="absolute inset-0 bg-black opacity-50"></div>
        <div class="relative z-10 text-white font-bold text-xl">Recursos</div>
      </div>
    </button>

    <!-- Eventos -->
    <button (click)="openModal('Eventos')"
      class="w-full md:w-1/3 rounded-lg overflow-hidden shadow-md cursor-pointer"
      [style.background]="
        'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/assets/eventos-bg.jpg)'
      "
      [style.background-position]="'center'"
      [style.background-size]="'cover'">
      <div class="relative h-48 flex items-center justify-center">
        <div class="absolute inset-0 bg-black opacity-50"></div>
        <div class="relative z-10 text-white font-bold text-xl">Eventos</div>
      </div>
    </button>

    <!-- Noticias -->
    <div class="w-full md:w-1/3 rounded-lg overflow-hidden shadow-md bg-gradient-to-r from-blue-900 to-blue-700 p-4">
      <div class="flex items-center space-x-2 mb-4">
        <i class="fas fa-layer-group text-gray-300 fa-sm"></i>
        <h2 class="text-xl font-bold text-white">Noticias</h2>
      </div>
      <div class="news-wrapper flex flex-col text-left">
        <div class="flex justify-between text-sm mb-2">
          <h3 class="font-semibold text-white">Nombre</h3>
          <span class="text-gray-300">Hace 1 día</span>
        </div>
        <h2 class="text-md text-white">Colaboradores - Nombre de la compañía</h2>
        <p class="text-sm text-gray-200 mt-2">
          Bienvenidos equipo Universidad El Bosque A continuación encontrarán una breve cápsula con puntos claves para la navegación en plataforma.
        </p>
        <a class="text-xs text-gray-300 self-end mt-4">Ver más</a>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div *ngIf="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div id="modal" class="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
      <h2 class="text-2xl font-bold text-gray-800">{{ selectedCard }}</h2>
      <p class="mt-4 text-gray-600">Contenido del modal para {{ selectedCard }}. Personaliza según necesidad.</p>
      <button (click)="closeModal()" class="mt-6 bg-secondary text-white py-2 px-4 rounded-lg shadow-md hover:bg-opacity-90 transition-colors duration-300">
        Cerrar
      </button>
    </div>
  </div>
</div>